import { KeyboardEvent, useState } from "react";
import { useContent } from "../../i18n";
import "../Providers/style.scss";
import "./style.scss";

export const Capabilities = () => {
  const { capabilities } = useContent();
  const [active, setActive] = useState(0);
  const tabs = capabilities.tabs;
  const current = tabs[active];

  // Arrow keys move between tabs, following the reading direction.
  const onKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    const rtl = document.documentElement.dir === "rtl";
    const forward = rtl ? "ArrowLeft" : "ArrowRight";
    const back = rtl ? "ArrowRight" : "ArrowLeft";
    if (e.key !== forward && e.key !== back) return;
    const next = (active + (e.key === forward ? 1 : -1) + tabs.length) % tabs.length;
    setActive(next);
    document.getElementById(`cap-tab-${tabs[next].id}`)?.focus();
  };

  return (
    <div id="capabilities" className="capabilities-wrapper">
      <div className="container">
        <h2>{capabilities.title}</h2>
        <p className="section-intro">{capabilities.intro}</p>

        <div className="cap-tabs" role="tablist" onKeyDown={onKeyDown}>
          {tabs.map((tab, i) => (
            <button
              key={tab.id}
              id={`cap-tab-${tab.id}`}
              type="button"
              role="tab"
              aria-selected={i === active}
              aria-controls="cap-panel"
              tabIndex={i === active ? 0 : -1}
              className={i === active ? "cap-tab active" : "cap-tab"}
              onClick={() => setActive(i)}
            >
              {tab.label}
              <span className="cap-count">{tab.items.length}</span>
            </button>
          ))}
        </div>

        <div
          id="cap-panel"
          className="info-grid three cap-panel"
          role="tabpanel"
          aria-labelledby={`cap-tab-${current.id}`}
        >
          {current.items.map((item) => (
            <div className="info-card" key={item.t}>
              <h4>{item.t}</h4>
              <p>{item.d}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
